import styled from 'styled-components';
import screen from 'superior-mq';
import { bp } from 'Styles/helpers';

const Container = styled.div`
  width: var(--container);
  margin: auto;

  ${screen.below(bp.mobile, `
    width: 100%;
    padding: 0 40px;
  `)}

  ${screen.below(bp.mobileSm, `
    padding: 0 20px;
  `)}
`;

export default Container;
